module.exports = __webpack_public_path__ + "static/media/justChevron.9c1d1be1.svg";